import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationService, JobService, OrderService, PrinterService, RfidProductionService, ScannerService } from 'app/services';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from 'app/i18n';
import { SET_JOB_DETAILS_VIEW } from 'ngrx/actions';
import { COLLATED, COLLATING, HOLD, PACKING, PRINTED, REPRINT, RFID, STATIONARY, rfidChipTypes } from 'ngrx/status-types';
import { BsModalService } from 'ngx-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { EXCESS_CARDS_SCRAP_CODE, SCRAP_CATEGORIES } from '../../shared/models/scrap-reasons.model';
import { VALIDATED } from '../../../ngrx/status-types';

@Component({
  selector: 'rfid-validation',
  templateUrl: 'rfid-validation.component.html',
  styleUrls: ['rfid-validation.component.scss']
})
export class RFIDValidation implements OnInit, OnDestroy {
  @Input('status') status;
  @Input('job') job;
  @Input('order') order;
  process: Observable<string>;
  isAdmin: boolean;
  isSupervisor: boolean;
  category: string;
  initSubscriptions: Subscription[];
  sheetEst: string;
  numQty: string
  sheetErr: boolean;
  sheetErr2: boolean;
  success: boolean;
  jobIncomplete: boolean;
  errCount: number;
  jobIncompleteErrMessage: string;
  jobIncompleteSheetEst: string;
  stationStatus: boolean = false;
  stationStatus2: boolean = false;
  stationStatus3: boolean = false;
  invalidStationScan: boolean = false;
  finishQty: number;
  rfidChipType: string[];
  chipType: string;
  collatingForm: FormGroup;
  collatedForm: FormGroup;
  countForm: FormGroup;
  countValidationError = false;
  countValidationErrorMessage = 'RFID_COUNT_ERROR';
  countValidationSuccess = false;
  Math = Math;
  qualityForm: FormGroup;

  constructor(
    private authService: AuthenticationService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private modalService: BsModalService,
    private scanner: ScannerService,
    private orderService: OrderService,
    private jobService: JobService,
    private printerService: PrinterService,
    private store: Store<any>,
    private rfidProductionService: RfidProductionService
  ) {
    this.process = this.authService.getCurrentProcess();
    this.isAdmin = this.authService.userIsAdmin();
    this.isSupervisor = this.authService.userIsSupervisor();
    this.rfidChipType = rfidChipTypes;
  }

  ngOnInit(): void {
    console.log('status', this.status)
    console.log('job', this.job)
    this.sheetEst = '';
    this.numQty = this.job.qty + '';
    this.errCount = 0;
    this.stationStatus = false;
    this.stationStatus3 = false;
    this.invalidStationScan = false;

    this.initSubscriptions = [
      this.process.subscribe(process => {
        this.category = process;
      }),

      this.scanner
        ._rfidScanListener
        .subscribe(id => {
          const ID = id.replace(/[^A-Za-z0-9_]/g, '');
          const [l, t] = this.scanner._triggers;
          const location = this.scanner._locations[l];
          const type = this.scanner._types[t];
          const [orderID, jobID, sideType] = ID.split('_');
          const updatedSideType = sideType && sideType.toLocaleLowerCase();
          console.log("🚀 ~ updatedSideType:", updatedSideType)

          console.log(`CODE ${ID} scanned at ` + location);
          console.log(`orderID ${orderID} - jobID ${jobID} - sideType ${sideType}`);
          //Example : 103-510-245 735-948 
          if (location === RFID && type === STATIONARY) {
            if (orderID == this.job.orderId && jobID == this.job.id && (updatedSideType == 'front' || updatedSideType == 'frente')) {
              console.log('Station 1 Scanned successfully');
              this.stationStatus3 = true;
            } else if (orderID == this.job.orderId && jobID == this.job.id && (updatedSideType == 'back' || updatedSideType == 'reverso')) {
              console.log('Station 3 Scanned successfully');
              this.stationStatus = true;
            } else if (ID == this.job.rfid_chipType) { //TBD: CHIP TYPE SCAN
              this.collatingForm.patchValue({
                chipType: this.job.rfid_chipType
              })
            } else {
              this.invalidStationScan = true;
              if (!this.stationStatus) { this.stationStatus = false; }
              if (!this.stationStatus3) { this.stationStatus3 = false; }
            }

            //TEMP --- TESTING PURPOSES
            // if(ID === '1'){
            //   console.log('Station 1 Scanned successfully');
            //  this.stationStatus = true;
            // }else if(ID === '3'){
            //   this.stationStatus3 = true;
            // }else if(ID == this.job.rfid_chipType){ //TBD: CHIP TYPE SCAN
            //   // this.chipType = this.job.rfid_chipType;
            //   // this.stationStatus2 = true;
            //   this.collatingForm.patchValue({
            //     chipType: this.job.rfid_chipType
            //   })
            // }else{
            //   this.invalidStationScan = true;
            //   if(!this.stationStatus){ this.stationStatus = false; }
            //   // if(!this.stationStatus2){ this.stationStatus2 = false; }
            //   // if(!this.collatingForm.value.chipType) {this.collatingForm.controls['collatingQty'].setErrors({})}
            //   if(!this.stationStatus3){ this.stationStatus3 = false; }
            // }

            if (this.stationStatus && this.stationStatus3) { this.invalidStationScan = false; }
          }
        })
    ]

    this.createForms();
  }

  closeModal(): void {

  }

  createForms(): void {
    this.collatingForm = this.fb.group({
      // collatingQty : [null, [ Validators.required, Validators.min(this.job.sheets)]],
      collatingQty: [{ value: this.job.sheets, disabled: true }],
      // missingQty :  [null, [ Validators.required, Validators.min(0)]],
      chipType: [null, [Validators.required]],
    });

    this.collatedForm = this.fb.group({
      missingQty: [null, [Validators.required, Validators.min(0)]],
    });

    this.countForm = this.fb.group({
      cardCount: [null, [Validators.required, Validators.min(1)]]
    });

    this.qualityForm = this.fb.group({
      checkMarkToMark: [false, [Validators.requiredTrue]],
      checkChipToImpression: [false, [Validators.requiredTrue]],
    });
  }

  async updateJob(status, excessCount = 0): Promise<void> {
    console.log("🚀 ~ RFIDValidation ~ updateJob ~ excessCount:", excessCount)

    const user = JSON.parse(localStorage.getItem('currentUser'));
    const timestamp = new Date().getTime().toString();

    if (this.category == RFID && status == 'collating') {
      this.status = 'qualityCheck';
    } else if (this.category == RFID && status == 'collated') {
      this.store.dispatch({
        type: SET_JOB_DETAILS_VIEW,
        payload: { loading: true }
      });
      this.modalService.hide(1);

      if (this.collatedForm.value.missingQty > 0) {
        console.log('Missing Sheets -- Sending job on Hold for Reprint')
        this.sendJobToReprint(this.collatedForm.value.missingQty, `Missing ${this.collatedForm.value.missingQty} set(s)`);

      } else {
        console.log('No missing sheets -- update as normal')
        const updatedJob = Object.assign({}, this.job, {
          activity_history: [{
            activity: COLLATED,
            note: this.translate.instant('JOB_STATUS_UPDATED'),
            timestamp,
            user: user.email
          }, ...this.job.activity_history]
        });

        updatedJob.status = COLLATED;
        updatedJob.previous_status = this.job.status;

        this.orderService.updateJob(updatedJob);

        const jobData = {
          id: this.job.id,
          orderId: this.job.orderId || '',
          rfid_code: this.job.rfid_code || '',
          rfid_chipType: this.job.rfid_chipType || '',
          rfid_tech: this.job.rfid_tech || '',
          rfid_finishType: this.job.rfid_finishType || '',
          qty: this.job.qty || 0,
          reprintCount: this.job.reprintCount || 0,
          rfid_inlayPartNumber: this.job.rfid_inlayPartNumber || this.job.inlay_part_number || '',
          product: this.job.product.sku || this.job.product || '',
          sheets: this.job.sheets || 0
        };

        let inlayUsed = 0;
        let minInlayUsed = Math.min(this.job.rfid_artworks.front.sheet_print_qty, this.job.rfid_artworks.back.sheet_print_qty);
        inlayUsed = minInlayUsed;

        // Consumption data
        const consumption = {
          inlay_sheets_used: 0, // Set to 0 as we only track scrap now, this gets populated in the backend on creation
          inlay_sheets_scrap: 0, // Default to 0 scrap unless you have a way to gather this
          inlay_part_number: this.job.rfid_inlayPartNumber || '' // Use existing value if available
        };

        console.log(`Recording inlay consumption for job ${this.job.id}: ${this.job.sheets} sheets used`);
        
        this.rfidProductionService.recordInlaySheetConsumption(
          this.job.id,
          jobData,
          consumption
        ).subscribe(
          result => {
            console.log('Successfully recorded inlay sheet consumption:', result);
          },
          error => {
            console.error('Error recording inlay sheet consumption:', error);
            // Optionally show an error notification to the user, but don't block the workflow
          }
        );
      }
    } else if (this.category == RFID && status == 'packing') {
      this.store.dispatch({
        type: SET_JOB_DETAILS_VIEW,
        payload: { loading: true }
      });
      this.modalService.hide(1);

      // Build the comment string
      const updatedJob = Object.assign({}, this.job, {});

      if (excessCount > 0) {
        let commentText = `Excess - ${excessCount} card(s)`;
        updatedJob.activity_history = [{
          activity: PACKING,
          note: 'QA CHECK',
          timestamp,
          user: user.email,
          comment: commentText,
        }, ...this.job.activity_history]
      };
        
      // Record excess cards as scrap material
      this.recordExcessCardsAsScrap(excessCount);

      // console.log('Updating job to packing . . .')
      this.orderService.setJobStatus(updatedJob, PACKING);

      setTimeout(() => {
        this.modalService.hide(1)
      }, 2500);

      // Print label after modal closes to ensure that it doesn't hang on updates
      // console.log('Begin printing box labels . . .')
      // await Promise.all([
      //   this.printBoxLabels()
      // ]);
      // console.log('Finish printing box labels . . .')
    }
  }

  onChipTypeChange(value): void {
    console.log(value)

    if (value) {
      if (this.collatingForm.value.chipType) {

      }
      // this.machineWidgetForm.controls.hour.enable();
    }
  }

  ngOnDestroy(): void {
    console.log("Destroying...");
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.stationStatus = false;
    this.stationStatus3 = false;
    this.invalidStationScan = false;
  }

  async printRFIDInnerCase(): Promise<void> {
    try {
      const fileName = `innerCaseLabel-${this.job.orderId}-${this.job.id}.pdf`;
      const pdfSource = await this.jobService.getRFIDInnerCasePDF(fileName);

      if (pdfSource) {
        // Print the PDF
        await this.printerService.printRFID(pdfSource, 'rfidInnerCaseLabel', fileName, 1);
        console.log('RFID inner case labels printed successfully');
      } else {
        console.error('Failed to get PDF source');
      }

    } catch (error) {
      console.error('Error printing RFID inner case labels:', error);
    }
  }

  async printBoxLabels(): Promise<void> {
    try {
      // CONFIGURABLE VALUES
      const keycardsPerInnerBox = 200;
      const innerBoxesPerOuterBox = 10;
      const keycardsPerOuterBox = keycardsPerInnerBox * innerBoxesPerOuterBox;

      // Calculate boxes needed
      const totalFullOuterBoxes = Math.floor(this.job.qty / keycardsPerOuterBox);
      const remainingKeycards = this.job.qty % keycardsPerOuterBox;

      const payload = [];

      // Add full boxes (2000 keycards each)
      if (totalFullOuterBoxes > 0) {
        payload.push({
          poNumber: this.order.poNumber,
          salesOrderNumber: this.order.salesOrderNumber,
          rfid_description: this.job.rfid_description,
          rfid_chipType: this.job.rfid_chipType,
          rfid_code: this.job.rfid_code,
          qty: keycardsPerOuterBox, // 2000 keycards per full box
          rfid_coo: this.job.rfid_coo,
          outsource: this.order.customer.outsource,
          isFullBox: true
        });
      }

      // Add partial box if there are remaining keycards
      if (remainingKeycards > 0) {
        payload.push({
          poNumber: this.order.poNumber,
          salesOrderNumber: this.order.salesOrderNumber,
          rfid_description: this.job.rfid_description,
          rfid_chipType: this.job.rfid_chipType,
          rfid_code: this.job.rfid_code,
          qty: remainingKeycards,
          rfid_coo: this.job.rfid_coo,
          outsource: this.order.customer.outsource,
          isFullBox: false
        });
      }

      const labels = await this.orderService.generateBoxLabels(payload);

      // Total number of boxes (full + partial)
      const totalBoxes = totalFullOuterBoxes + (remainingKeycards > 0 ? 1 : 0);

      // Print labels for each box
      for (let i = 0; i < totalBoxes; i++) {
        if (labels.outerBoxLabels[i]) {
          await this.printerService.printRFID(
            labels.outerBoxLabels[i],
            'rfidBoxLabels',
            `Outer Box Label ${i + 1}`,
            1
          );
        }
      }

      console.log('Box labels printed successfully');

    } catch (error) {
      console.error('Error printing box labels:', error);
      throw error;
    }
  }

  validateCount(): void {
    const cardCount = this.countForm.get('cardCount').value;
    const expectedCount = this.job.qty;

    this.countValidationError = false;
    this.countValidationSuccess = false;

    // Calculate missing cards
    const missingCards = expectedCount - cardCount;

    if (expectedCount - cardCount > 0) {
      // Calculate missing sets - every 21 cards = 1 set, round up
      const missingSets = Math.ceil(missingCards / 21);

      // Use the refactored method
      this.sendJobToReprint(missingSets, `Calculated from ${missingCards} cards`);
    } else {
      let excessCount = cardCount - expectedCount
      if (excessCount > 0) {
        // More cards than expected
        this.countValidationError = true;
        this.countValidationErrorMessage = 'RFID_COUNT_ERROR';
      } else {
        // Counts match exactly
        this.countValidationSuccess = true;
      }
      // this.updateJob('packing', excessCount);
      this.updateJob('packing', excessCount);
    }
  }

  /**
   * Puts a job on hold for reprint
   * @param missingSets Number of missing sets
   * @param comment Optional comment with additional details 
   */
  sendJobToReprint(missingSets: number, comment?: string): void {
    this.modalService.hide(1);

    this.store.dispatch({
      type: SET_JOB_DETAILS_VIEW,
      payload: { loading: true }
    });

    const user = JSON.parse(localStorage.getItem('currentUser'));
    const timestamp = new Date().getTime().toString();

    console.log('Sending job on Hold for Reprint');

    // Build the comment string
    let commentText = `Missing ${missingSets} set(s)`;
    if (comment) {
      commentText += ` - ${comment}`;
    }

    const updatedJob = Object.assign({}, this.job, {
      activity_history: [{
        activity: HOLD,
        note: REPRINT,
        timestamp,
        user: user.email,
        comment: commentText,
      }, ...this.job.activity_history]
    });

    updatedJob.previous_status = PRINTED; // When they resume, it's back to printed
    updatedJob.status = HOLD;
    // updatedJob.rfid_missingSheetQty = missingSets * 2; // 1 set = 2 sheets of printed paper, 1 inlay sheet, basically 21 completed RFID cards
    updatedJob.rfid_missingSheetQty = missingSets;

    this.orderService.updateJob(updatedJob);
  }

  proceedToCollating(): void {
    this.modalService.hide(1);
    
    this.store.dispatch({
      type: SET_JOB_DETAILS_VIEW,
      payload: { loading: true }
    });
    
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const timestamp = new Date().getTime().toString();
    
    const updatedJob = Object.assign({}, this.job, {
      activity_history: [{
        activity: COLLATING,
        note: this.translate.instant('JOB_STATUS_UPDATED'),
        timestamp,
        user: user.email
      }, ...this.job.activity_history]
    });
    
    updatedJob.status = COLLATING;
    updatedJob.previous_status = this.job.status;
    
    // Paper consumption is now handled automatically when transitioning from PRINTING to PRINTED
    // in the backend via the DynamoDB stream handler
    
    this.orderService.updateJob(updatedJob);
  }

  /**
   * Records excess cards as scrap material
   * Each card consists of: 
   * - Front and back paper sheets (2 sheets)
   * - Inlay sheet (1 sheet)
   * - Front and back laminate ( 2 press sheets CONVERTED to square feet)
   * 
   * @param excessCardCount The number of excess cards found during validation
   */
  private recordExcessCardsAsScrap(excessCardCount: number): void {
    // Calculate sets based on excess card count (21 cards per set)
    const excessSets = Math.ceil(excessCardCount / 21);
    
    // Create job data object for the production service
    const jobData = {
      id: this.job.id,
      orderId: this.job.orderId || '',
      rfid_code: this.job.rfid_code || '',
      rfid_chipType: this.job.rfid_chipType || '',
      rfid_tech: this.job.rfid_tech || '',
      rfid_finishType: this.job.rfid_finishType || '',
      qty: this.job.qty || 0,
      reprintCount: this.job.reprintCount || 0,
      rfid_inlayPartNumber: this.job.rfid_inlayPartNumber || this.job.inlay_part_number || '',
      product: this.job.product.sku || this.job.product || '',
      sheets: this.job.sheets || 0
    };
    console.log(`Recording excess cards as scrap: ${excessCardCount} cards (${excessSets} sets)`);
    
    // Calculate sheets per set to get scrap quantities
    const pressSheetsPerSet = 1; // Each set consists of 1 sheet per side (which makes 21 cards)
    const frontSheetScrap = excessSets * pressSheetsPerSet;
    const backSheetScrap = excessSets * pressSheetsPerSet;
    const inlaySheetScrap = excessSets * pressSheetsPerSet;
    
    // For laminate, we need to convert to square feet
    // Sheet dimensions: 18" x 12"
    const SHEET_WIDTH_INCHES = 18;
    const SHEET_HEIGHT_INCHES = 12;
    
    // Calculate square feet per sheet
    // 1 square foot = 144 square inches (12" x 12")
    const squareFeetPerSheet = (SHEET_WIDTH_INCHES * SHEET_HEIGHT_INCHES) / 144;
    
    // Calculate total square feet of laminate scrap
    const frontLaminateScrap = frontSheetScrap * squareFeetPerSheet;
    const backLaminateScrap = backSheetScrap * squareFeetPerSheet;
    
    console.log(`Excess scrap quantities:`);
    console.log(`- Paper sheets: Front = ${frontSheetScrap}, Back = ${backSheetScrap}`);
    console.log(`- Inlay sheets: ${inlaySheetScrap}`);
    console.log(`- Laminate (sq ft): Front = ${frontLaminateScrap}, Back = ${backLaminateScrap}`);
    
    // Create a base scrap record - always include paper sheets
    const scrapRecord = {
      scrap_category: SCRAP_CATEGORIES.VERIFICATOR,
      scrap_code: EXCESS_CARDS_SCRAP_CODE,
      scrap_reason: 'Excess Cards', // User-friendly description
      job_status: VALIDATED,
      front_sheets_scrap: frontSheetScrap,
      back_sheets_scrap: backSheetScrap
    };
    
    // At VALIDATED stage, we always include inlay and laminate in the scrap record
    // Add inlay scrap data
    scrapRecord['inlay_sheets_scrap'] = inlaySheetScrap;
    
    // Add laminate scrap data
    scrapRecord['front_laminate_scrap'] = frontLaminateScrap;
    scrapRecord['back_laminate_scrap'] = backLaminateScrap;
    
    // 1. Record paper sheet scrap
    this.rfidProductionService.recordPaperSheetConsumption(
      this.job.id,
      jobData,
      {
        front_sheets_used: 0, // Not adding to usage, only to scrap
        back_sheets_used: 0,
        front_sheets_scrap: frontSheetScrap,
        back_sheets_scrap: backSheetScrap,
        scrap_record: scrapRecord
      }
    ).subscribe(
      result => console.log('Successfully recorded paper scrap for excess cards:', result),
      error => console.error('Error recording paper scrap for excess cards:', error)
    );
    
    // 2. Record inlay sheet scrap
    this.rfidProductionService.recordInlaySheetConsumption(
      this.job.id,
      jobData,
      {
        inlay_sheets_used: 0, // Not adding to usage, only to scrap
        inlay_sheets_scrap: inlaySheetScrap,
        inlay_part_number: this.job.rfid_inlayPartNumber || this.job.inlay_part_number || ''
        // Don't include scrap_record here as it's already in the paper consumption call
      }
    ).subscribe(
      result => console.log('Successfully recorded inlay scrap for excess cards:', result),
      error => console.error('Error recording inlay scrap for excess cards:', error)
    );
    
    // 3. Record laminate scrap
    const laminateType = this.job.rfid_finishType || '';
    this.rfidProductionService.recordLaminateConsumption(
      this.job.id,
      jobData,
      {
        front_laminate_feet_used: 0, // Not adding to usage, only to scrap
        back_laminate_feet_used: 0,
        front_laminate_scrap: frontLaminateScrap,
        back_laminate_scrap: backLaminateScrap,
        laminate_type: laminateType
        // Don't include scrap_record here as it's already in the paper consumption call
      }
    ).subscribe(
      result => console.log('Successfully recorded laminate scrap for excess cards:', result),
      error => console.error('Error recording laminate scrap for excess cards:', error)
    );
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/RFID/rfid-validation/rfid-validation.component.ts